import { Action } from "../Actions/actionRepository";
import { Trigger } from "./triggerRepository";
import { addEvent, removeEvent } from "../lib/eventHandler";

export interface ElementOnTriggerParam {
    selector: string;
}

export class ElementOnTrigger implements Trigger {
    params: ElementOnTriggerParam;

    constructor(params: ElementOnTriggerParam) {
        this.params = params;
    }

    init = (act: Action) => {
        var isInViewport = (element: any) => {
            var bounding = element.getBoundingClientRect();
            if (
                bounding.top >= 0 &&
                bounding.left >= 0 &&
                bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
            ) {
                return true;
            }
            return false;
        };
        var fn = () => {
            var elements = document.querySelectorAll(this.params.selector);
            for (var i = 0; (i = elements.length); i++) {
                if (isInViewport(elements[i])) {
                    act.execute();
                    removeEvent(window, "scroll", fn);
                    return;
                }
            }
        };
        addEvent(window, "scroll", fn);
    };
}
